/**
 * PHI DIGITAL - Validación de Documentación e Identidad de Cliente
 */

// Validar CUIL (Argentina)
function esCUILValido(cuil) {
  const cuilLimpio = cuil.toString().replace(/[-_ ]/g, '');

  if (!/^\d{11}$/.test(cuilLimpio)) return false;

  const multiplicadores = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
  let suma = 0;

  for (let i = 0; i < 10; i++) {
    suma += parseInt(cuilLimpio.charAt(i), 10) * multiplicadores[i];
  }

  const resto = suma % 11;
  let digitoEsperado;

  if (resto === 0) {
    digitoEsperado = 0;
  } else if (resto === 1) {
    const prefijo = cuilLimpio.substring(0, 2);
    if (prefijo === '23') {
      digitoEsperado = parseInt(cuilLimpio.charAt(10), 10);
    } else {
      return false;
    }
  } else {
    digitoEsperado = 11 - resto;
  }

  return digitoEsperado === parseInt(cuilLimpio.charAt(10), 10);
}

// Validar RUT / RUN (Chile - Módulo 11)
function esRUTValido(rut) {
  const rutLimpio = rut.toString().replace(/[\.\-_ ]/g, '').toUpperCase();

  if (!/^[0-9]{7,8}[0-9K]$/.test(rutLimpio)) return false;

  const cuerpo = rutLimpio.slice(0, -1);
  const dvIngresado = rutLimpio.slice(-1);

  let suma = 0;
  let multiplicador = 2;

  for (let i = cuerpo.length - 1; i >= 0; i--) {
    suma += parseInt(cuerpo.charAt(i), 10) * multiplicador;
    multiplicador = multiplicador === 7 ? 2 : multiplicador + 1;
  }

  const resto = suma % 11;
  const dvCalculado = 11 - resto;

  let dvEsperado = '';
  if (dvCalculado === 11) {
    dvEsperado = '0';
  } else if (dvCalculado === 10) {
    dvEsperado = 'K';
  } else {
    dvEsperado = dvCalculado.toString();
  }

  return dvIngresado === dvEsperado;
}

// Validar antes de redirigir a Checkout
function validarCheckout(e) {
  const documentType = document.getElementById('main-document-type');
  const documentNumber = document.getElementById('main-document-number');
  const isCorporate = document.getElementById('main-is-corporate');

  if (!documentType || documentType.value === '') {
    e.preventDefault();
    alert('Por favor, selecciona el Tipo de Documento.');
    documentType?.focus();
    return false;
  }

  if (!documentNumber || documentNumber.value.trim() === '') {
    e.preventDefault();
    alert('Por favor, completa el Número de Documento.');
    documentNumber?.focus();
    return false;
  }

  const docVal = documentNumber.value.trim();

  if (documentType.value === 'CUIL') {
    if (!/^\d{11}$/.test(docVal)) {
      e.preventDefault();
      alert('El CUIL debe contener exactamente 11 números, sin guiones ni espacios.');
      documentNumber.focus();
      return false;
    }

    if (!esCUILValido(docVal)) {
      e.preventDefault();
      alert('El CUIL ingresado no es válido. Verifica el número e inténtalo nuevamente.');
      documentNumber.focus();
      return false;
    }
  }

  if (documentType.value === 'RUT' || documentType.value === 'RUN') {
    if (!esRUTValido(docVal)) {
      e.preventDefault();
      alert('El RUT/RUN ingresado no es válido. Ingresa el número con o sin guión (ej: 12345678-K).');
      documentNumber.focus();
      return false;
    }
  }

  if (!isCorporate || isCorporate.value === '') {
    e.preventDefault();
    alert('Por favor, selecciona el Tipo de Cliente.');
    isCorporate?.focus();
    return false;
  }

  return true;
}

// Sincronizar atributos con la Cart API vía form-urlencoded
async function guardarAtributosCarrito() {
  const docType = document.getElementById('main-document-type')?.value || '';
  const docNum = document.getElementById('main-document-number')?.value || '';
  const isCorp = document.getElementById('main-is-corporate')?.value || '';

  const bodyParams = new URLSearchParams();
  bodyParams.append('attributes[_janisCommerce_customer_documentType]', docType);
  bodyParams.append('attributes[_janisCommerce_customer_documentNumber]', docNum);
  bodyParams.append('attributes[_janisCommerce_customer_isCorporate]', isCorp);

  try {
    await fetch((window.routes ? window.routes.cart_update_url : '/cart/update') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: bodyParams
    });
  } catch (err) {
    console.error('Error al guardar atributos de cliente:', err);
  }
}

// Event Listeners
document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('click', function(e) {
    const botonCheckout = e.target.closest('#checkout, [name="checkout"]');
    if (!botonCheckout) return;

    validarCheckout(e);
  }, true);

  const inputs = ['main-document-type', 'main-document-number', 'main-is-corporate'];
  inputs.forEach(id => {
    const el = document.getElementById(id);
    if (el) {
      el.addEventListener('change', guardarAtributosCarrito);
      if (el.tagName === 'INPUT') {
        el.addEventListener('blur', guardarAtributosCarrito);
      }
    }
  });
});
